import { render } from "./Intro.vue?vue&type=template&id=dd066c34"
import script from "./Intro.vue?vue&type=script&lang=js"
export * from "./Intro.vue?vue&type=script&lang=js"

import "./Intro.vue?vue&type=style&index=0&id=dd066c34&lang=css"
script.render = render

export default script